import CONSTANTS from '../constants'
import { deleteRequest, downloadFile, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'

// Calls the API to get Facility Initials
export const getPermitDataList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_PERMIT_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_PERMIT_LIST_REQUEST })
    return getRequest(APICONFIG.getPermitDataUrl).then((res) => {
        let resObject = res
        dispatch(addEventLog(resObject, CONSTANTS.GET_PERMIT_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_PERMIT_LIST_SUCCESS, data: res?.data })
        return res
    }).catch((err) => {
        let errObject = err
        dispatch(addEventLog(errObject, CONSTANTS.GET_PERMIT_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_PERMIT_LIST_FAILURE })
        return err
    })
}

// Calls the API to get Facility Initials
export const getActivePermitList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_ACTIVE_PERMIT_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_ACTIVE_PERMIT_LIST_REQUEST })
    return getRequest(APICONFIG.getPermitDataUrl).then((res) => {//getActivePermitDataUrl
        let resObject = res
        dispatch(addEventLog(resObject, CONSTANTS.GET_ACTIVE_PERMIT_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_ACTIVE_PERMIT_LIST_SUCCESS, data: res?.data })
        return res
    }).catch((err) => {
        let errObject = err
        dispatch(addEventLog(errObject, CONSTANTS.GET_ACTIVE_PERMIT_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_ACTIVE_PERMIT_LIST_FAILURE })
        return err
    })
}

// GET VEHICLE LIST DETAILS
export const getVehicleDataList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_VEHICLE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_REQUEST })
    return getRequest(`${APICONFIG.getVehicleListUrl}/page/1`).then((res) => {
        let resObject = res
        dispatch(addEventLog(resObject, CONSTANTS.GET_VEHICLE_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = err
        dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_FAILURE })
    })
}

// Post Vehicle Details
export const postVehicleList = (data) => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.POST_VEHICLE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_REQUEST })
    return postRequest(APICONFIG.postVehicleListUrl, data).then((res) => {
        let resObject = res
        dispatch(addEventLog(resObject, CONSTANTS.POST_VEHICLE_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = err
        dispatch(addEventLog(errObject, CONSTANTS.POST_VEHICLE_LIST_FAILURE))
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_FAILURE })
    })
}

// Delete Vehicle Details

export const DeleteVehicleList = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.DELETE_VEHICLE_ITEM_REQUEST))
    dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_REQUEST })
    return deleteRequest(`${APICONFIG.deleteVehicleItemUrl}/${id}`).then((res) => {
        let resObject = { ...res, id: id }
        dispatch(addEventLog(resObject, CONSTANTS.DELETE_VEHICLE_ITEM_SUCCESS))
        dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_SUCCESS })
        return res.data
    }).catch((err) => {
        let errObject = { ...err, id: id }
        dispatch(addEventLog(errObject, CONSTANTS.DELETE_VEHICLE_ITEM_FAILURE))
        dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_FAILURE })
    })
}


export const CancelPermit = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.CANCEL_PERMIT_REQUEST))
    dispatch({ type: CONSTANTS.CANCEL_PERMIT_REQUEST })
    return getRequest(`${APICONFIG.cancelPermitUrl}/${id}`).then((res) => {
        let resObject = { ...res, id: id }
        dispatch(addEventLog(resObject, CONSTANTS.CANCEL_PERMIT_SUCCESS))
        dispatch({ type: CONSTANTS.CANCEL_PERMIT_SUCCESS })
        return res.data
    }).catch((err) => {
        let errObject = { ...err, id: id }
        dispatch(addEventLog(errObject, CONSTANTS.CANCEL_PERMIT_FAILURE))
        dispatch({ type: CONSTANTS.CANCEL_PERMIT_FAILURE })
    })
}

// GET PERMIT QR
export const getPermitQR = (permitId, permitCode) => (dispatch) => {
    const payload = {
        permitId: permitId,
        permitCode: permitCode
    }
    dispatch(addEventLog(payload, CONSTANTS.GET_PERMIT_QR_REQUEST))
    dispatch({ type: CONSTANTS.GET_PERMIT_QR_REQUEST })
    return downloadFile(`${APICONFIG.getPermitQr}/${permitId}`, '', `${permitCode}.pdf`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_PERMIT_QR_SUCCESS))
        dispatch({ type: CONSTANTS.GET_PERMIT_QR_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_PERMIT_QR_FAILURE))
        dispatch({ type: CONSTANTS.GET_PERMIT_QR_FAILURE })
        return err
    })
}

// Renew permit data

export const PermitRenewData = (data) => (dispatch) => {
    dispatch(addEventLog(data, CONSTANTS.PERMIT_RENEW_REQUEST))
    dispatch({ type: CONSTANTS.PERMIT_RENEW_REQUEST })
    return postRequest(APICONFIG.permitrenewapi, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.PERMIT_RENEW_SUCCESS))
        dispatch({ type: CONSTANTS.PERMIT_RENEW_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = { ...data, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.PERMIT_RENEW_FAILURE))
        dispatch({ type: CONSTANTS.PERMIT_RENEW_FAILURE })
        return err
    })
}


// Renew permit data

export const AddServicePermitAction = (data) => (dispatch) => {
    dispatch(addEventLog(data, CONSTANTS.PERMIT_ADDSERVICE_REQUEST))
    dispatch({ type: CONSTANTS.PERMIT_ADDSERVICE_REQUEST })
    return postRequest(APICONFIG.permitAddServiceapi, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.PERMIT_ADDSERVICE_SUCCESS))
        dispatch({ type: CONSTANTS.PERMIT_ADDSERVICE_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = { ...data, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.PERMIT_ADDSERVICE_FAILURE))
        dispatch({ type: CONSTANTS.PERMIT_ADDSERVICE_FAILURE })
    })
}

export const CancelPermitRenew = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.CANCEL_PERMIT_REQUEST))
    dispatch({ type: CONSTANTS.CANCEL_PERMIT_REQUEST })
    return getRequest(`${APICONFIG.cancelPermitUrlRenew}/${id}`).then((res) => {
        let resObject = { ...res, id: id }
        dispatch(addEventLog(resObject, CONSTANTS.CANCEL_PERMIT_SUCCESS))
        dispatch({ type: CONSTANTS.CANCEL_PERMIT_SUCCESS })
        return res.data
    }).catch((err) => {
        let errObject = { ...err, id: id }
        dispatch(addEventLog(errObject, CONSTANTS.CANCEL_PERMIT_FAILURE))
        dispatch({ type: CONSTANTS.CANCEL_PERMIT_FAILURE })
    })
}

export const keycardReplacementRequestAction = (data) => (dispatch) => {
    dispatch(addEventLog(data, CONSTANTS.KEYCARD_REPLACEMENT_REQUEST))
    dispatch({ type: CONSTANTS.KEYCARD_REPLACEMENT_REQUEST })
    return postRequest(APICONFIG.keycardReplacementRequest, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.KEYCARD_REPLACEMENT_SUCCESS))
        dispatch({ type: CONSTANTS.KEYCARD_REPLACEMENT_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = { ...data, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.KEYCARD_REPLACEMENT_FAILURE))
        dispatch({ type: CONSTANTS.KEYCARD_REPLACEMENT_FAILURE })
    })
}

export const keycardReplacementDetails = (data) => (dispatch) => {
    dispatch(addEventLog(data, CONSTANTS.KEYCARD_REPLACEMENT_DETAILS_REQUEST))
    dispatch({ type: CONSTANTS.KEYCARD_REPLACEMENT_DETAILS_REQUEST })
    return postRequest(APICONFIG.keycardReplacementDetails, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.KEYCARD_REPLACEMENT_DETAILS_SUCCESS))
        dispatch({ type: CONSTANTS.KEYCARD_REPLACEMENT_DETAILS_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = { ...data, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.KEYCARD_REPLACEMENT_DETAILS_FAILURE))
        dispatch({ type: CONSTANTS.KEYCARD_REPLACEMENT_DETAILS_FAILURE })
    })
}